var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn--rounded",class:[_vm.style, _vm.small, _vm.addClass],attrs:{"title":_vm.title},on:{"click":_vm.click}},[(_vm.title.length > 0)?_c('span',{staticClass:"d--n"},[_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")]):_vm._e(),_c('q-icon',{attrs:{"icon":_vm.icon}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }